import { useAuthContext } from "providers/Auth";
import { Hide } from "shared/components";
import { formatToCurrency } from "shared/utils";
import {
  RentReportingData,
  EnrollmentCase
} from "views/rent-reporting-id/types";
import { PaymentStatusElement } from "./PaymentStatusElement";
import {
  formatPropertyName,
  formatAddress,
  buildDelinquencyOptions,
  formatDate
} from "../utils";
import { RvStatusType } from "views/rent-reporting/types";

interface MobileRentRowProps {
  row: { original: RentReportingData };
  selectedEnrollmentCase?: EnrollmentCase;
}

export const MobileRentRow = ({
  row,
  selectedEnrollmentCase
}: MobileRentRowProps) => {
  const { type } = useAuthContext();
  const options = buildDelinquencyOptions(
    row.original.available_delinquency_options
  );

  return (
    <div className="space-y-2">
      <p className="text-sm text-content-700 font-medium">
        {formatPropertyName(selectedEnrollmentCase)}
      </p>
      <p className="text-sm text-content-700">
        {formatAddress(selectedEnrollmentCase)}
      </p>
      <p className="text-sm text-content-700">
        {formatDate(row.original.for_month, "MMM YYYY")} -{" "}
        {formatToCurrency(row.original.rent_amount)}
      </p>
      <Hide if={type.isSDK}>
        <PaymentStatusElement
          status={
            {
              status: row.original.status,
              months_delinquency: row.original.months_delinquency
            } as RvStatusType
          }
          options={options}
          verificationId={row.original.id}
        />
      </Hide>
    </div>
  );
};
